
import React, { useState, useEffect } from 'react';
import { editDiscount, deleteDiscount } from '../utils/api';
import { mapErrorMessage } from '../utils/errorMapping';
import './_Modal.css';

const EditDiscountModal = ({ closeModal, refreshData, discount }) => {
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [type, setType] = useState(1);
    const [amount, setAmount] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        if (discount) {
            setName(discount.name);
            setDescription(discount.description);
            setType(discount.type);
            setAmount(discount.amount / 100);
        }
    }, [discount]);

    const handleEdit = async () => {
        try {
            const payload = {
                id: discount.id,
                name,
                description,
                type: parseInt(type),
                amount: parseFloat(amount) * 100
            };

            await editDiscount(payload);
            closeModal();
            refreshData();
        } catch (error) {
            const message = mapErrorMessage(error.message);
            setErrorMessage(message);
        }
    };

    const handleDelete = async () => {
        if (window.confirm('Are you sure you want to delete this discount?')) {
            try {
                await deleteDiscount(discount.id);
                closeModal();
                refreshData();
            } catch (error) {
                const message = mapErrorMessage(error.message);
                setErrorMessage(message);
            }
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <button onClick={closeModal} className="modal-close">&times;</button>
                <h2>Edit Discount</h2>
                {errorMessage && <p className="error">{errorMessage}</p>}
                <div className="form-group">
                    <input
                        type="text"
                        placeholder="Name"
                        value={name}
                        onChange={e => setName(e.target.value)}
                    />
                </div>
                <div className="form-group">
                    <input
                        type="text"
                        placeholder="Description"
                        value={description}
                        onChange={e => setDescription(e.target.value)}
                    />
                </div>
                <div className="form-group">
                    <select value={type} onChange={e => setType(parseInt(e.target.value))}>
                        <option value={1}>Fixed</option>
                        <option value={2}>Percent</option>
                    </select>
                </div>
                <div className="form-group">
                    <input
                        type="number"
                        placeholder="Amount"
                        value={amount}
                        onChange={e => setAmount(e.target.value)}
                    />
                </div>
                <div className="actions-centered">
                    <button onClick={closeModal} className="cancel-button text-button">Cancel</button>
                    <button onClick={handleEdit} className="submit-button text-button">Save Changes</button>
                    <button onClick={handleDelete} className="submit-button text-button">Delete</button>
                </div>
            </div>
        </div>
    );
};

export default EditDiscountModal;
